import * as fromSeriousSystem from '@serious-system';

import { environment } from '../../environments/environment';
import { ConnectorView } from '../_generated/model/connectorView';

export { ConnectorView } from '../_generated/model/connectorView';
/** A catalog id such as `atlassian`. Whatever shape the generated view gives it, we never widen it here. */
export type ConnectorProvider = ConnectorView['provider'];
export type ConnectorConnectionStatus = NonNullable<ConnectorView['status']>;

/** Consent requires browser navigation; data requests use the generated client. */
export const connectorConnectUrl = (provider: ConnectorProvider): string =>
  `${environment.appApiUrl}/v1/connectors/${provider}/connect`;

/**
 * The vendor mark to draw for a connector, derived from its provider id.
 *
 * Not carried on the wire, deliberately. The sprite lives in this repo, so a new vendor's logo
 * already needs a change here — sending the name from core-ai would have added a place to edit
 * without removing one, and would have put a presentation concern in the AI service. Keyed by
 * provider for the same reason the per-connector copy is.
 *
 * Catalog ids are snake_case and sprite ids kebab-case (`google_calendar` -> `google-calendar`).
 * A provider the sprite does not ship falls back to the generic icon.
 *
 * Lives here rather than in a component because two render connectors — the Connectors settings row
 * and the composer's "+" menu — and they must not drift.
 */
export const mcpMarkFor = (
  provider: string,
): fromSeriousSystem.McpIconsType | null => {
  const candidate = provider.replace(/_/g, '-');
  return fromSeriousSystem.isMcpIcon(candidate) ? candidate : null;
};
